/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, signal} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';

import {deferSignalStateWrite} from '../util/template-state';
import {SignalAdminResourcePageState} from '../controller/signal-admin-resource-page-state';
import {SignalAdminResourceModel} from '../controller/signal-admin-resource-api';
import {APP_SHARED} from '../app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule],
  selector: 'adn-route-two-panel-layout',
  template: `
    <div class="row">
      <ui-view class="col-sm-6" *ngIf="!displayPanelFull" name="leftPanel"></ui-view>
      <ui-view class="col-sm-8 col-sm-offset-2" *ngIf="displayPanelFull" name="leftPanelPartA"></ui-view>
      <ui-view class="col-sm-6" *ngIf="!displayPanelFull" name="rightPanel"></ui-view>
    </div>
  `
})
export class RouteTwoPanelLayoutComponent {
  /**
   * Template-bound panel mode. May lag the `full` input by one macrotask so
   * *ngIf does not flip mid-CD (NG0100) when a child redirects with full:true
   * or page state updates the layout.
   */
  private readonly panelFullState = signal(false);

  get panelFull(): boolean { return this.panelFullState(); }
  set panelFull(value: boolean) { this.panelFullState.set(value); }

  @Input() state: SignalAdminResourcePageState<SignalAdminResourceModel>;

  private fullInputSeen = false;

  @Input()
  set full(value: boolean) {
    this.applyFull(!!value);
  }

  get full(): boolean {
    return this.panelFull;
  }

  get displayPanelFull(): boolean {
    return this.state ? this.state.panelFull() : this.panelFull;
  }

  private applyFull(next: boolean): void {
    if (!this.fullInputSeen) {
      this.fullInputSeen = true;
      this.panelFull = next;
      return;
    }
    if (next === this.panelFull) {
      return;
    }
    deferSignalStateWrite(() => {
      this.panelFull = next;
    });
  }
}

@Component({
  standalone: true,
  imports: [UIRouterModule],
  selector: 'adn-route-two-panel-bottom-layout',
  template: `
    <div class="row">
      <ui-view class="col-sm-6" name="leftPanel"></ui-view>
      <ui-view class="col-sm-6" name="rightPanel"></ui-view>
    </div>
    <div class="row" style="margin-top: 15px">
      <ui-view class="col-sm-12" name="bottomPanel"></ui-view>
    </div>
  `
})
export class RouteTwoPanelBottomLayoutComponent {
}
